import { useState } from "react";
import { Phone, Menu, X, Facebook } from "lucide-react";
import { Button } from "@/components/ui/button";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_21ac811b-a248-4ccc-b1af-d39168c4c5ba/artifacts/mgckb403_1.png";
const BRAND_URL = "https://customer-assets.emergentagent.com/job_21ac811b-a248-4ccc-b1af-d39168c4c5ba/artifacts/q3hz0127_2.jpg";

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navLinks = [
    { href: "#about", label: "About Us" },
    { href: "#services", label: "Our Services" },
    { href: "#gallery", label: "Our Work" },
    { href: "#testimonials", label: "Reviews" },
    { href: "#contact", label: "Contact Us" },
  ];

  return (
    <>
      <header className="sticky top-0 bg-white z-40 shadow-sm" data-testid="header">
        {/* Top Row: Phone | Logo | Social */}
        <div className="border-b border-gray-100">
          <div className="max-w-7xl mx-auto px-4 md:px-8">
            <div className="flex items-center justify-between h-16 md:h-20 relative">
              {/* Phone - Left */}
              <a
                href="tel:07968790128"
                className="hidden md:flex items-center gap-2 text-gray-700 hover:text-[#1A4D2E] font-medium transition-colors"
                data-testid="header-phone"
              >
                <Phone className="w-4 h-4" />
                <span>07968 790128</span>
              </a>

              {/* Mobile menu button - Left on mobile */}
              <button
                className="md:hidden p-2 text-gray-700"
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                data-testid="mobile-menu-btn"
                aria-label="Toggle menu"
              >
                {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
              </button>

              {/* Logo - Centered via absolute positioning */}
              <a href="#" className="absolute left-1/2 -translate-x-1/2 flex items-center gap-1.5" data-testid="logo">
                <img
                  src={LOGO_URL}
                  alt="Pioneer Trees mascot"
                  className="h-12 md:h-16 w-auto"
                />
                <img
                  src={BRAND_URL}
                  alt="Pioneer Trees and Landscapes Ltd"
                  className="h-12 md:h-16 w-auto"
                />
              </a>

            {/* Social Icons - Right */}
              <div className="flex items-center gap-3">
                <a
                  href="https://www.facebook.com/pioneertreesandlandscapes"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 rounded-full border border-gray-200 flex items-center justify-center text-gray-500 hover:text-[#1A4D2E] hover:border-[#1A4D2E] transition-colors"
                  aria-label="Facebook"
                  data-testid="header-facebook"
                >
                  <Facebook className="w-4 h-4" />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Navigation Row - Desktop */}
        <div className="hidden md:block">
          <div className="max-w-7xl mx-auto px-4 md:px-8">
            <nav className="flex items-center justify-center gap-10 h-12" data-testid="desktop-nav">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="text-gray-600 hover:text-[#1A4D2E] text-sm font-medium tracking-widest uppercase transition-colors"
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>
        </div>
      </header>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div
          className="fixed inset-0 bg-white z-[9999] md:hidden overflow-y-auto"
          data-testid="mobile-menu"
        >
          <div className="flex items-center justify-between p-4 border-b">
            <div className="flex items-center gap-1">
              <img src={LOGO_URL} alt="Pioneer Trees mascot" className="h-10 w-auto" />
              <img src={BRAND_URL} alt="Pioneer Trees and Landscapes Ltd" className="h-8 w-auto" />
            </div>
            <button
              className="p-2 text-gray-700"
              onClick={() => setMobileMenuOpen(false)}
              aria-label="Close menu"
            >
              <X className="w-6 h-6" />
            </button>
          </div>
          <div className="p-6">
            <nav className="flex flex-col gap-1">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="text-base font-medium tracking-wider uppercase text-gray-600 hover:text-[#1A4D2E] py-4 border-b border-gray-100"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {link.label}
                </a>
              ))}
            </nav>
            <div className="mt-8 space-y-4">
              <a
                href="tel:07968790128"
                className="flex items-center justify-center gap-2 text-[#1A4D2E] font-semibold py-3 border-2 border-[#1A4D2E] rounded-full"
              >
                <Phone className="w-5 h-5" />
                07968 790128
              </a>
              <Button
                asChild
                className="bg-[#1A4D2E] hover:bg-[#143D24] text-white font-bold rounded-full w-full py-6"
              >
                <a href="#contact" onClick={() => setMobileMenuOpen(false)}>Get Free Quote</a>
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
